<template>
  <nav
    class="navbar"
    role="navigation"
    aria-label="main navigation"
    v-if="!($route.path == '/login')"
  >
    <div class="navbar-brand">
      <a
        class="navbar-item"
        @click="
          if (user_data) {
            $router.push({ name: 'home' });
          }
        "
      >
        <img
          src="/img/modul/Modul-12.png"
          alt="Admin Software Logo"
          width="112"
          height="28"
        />
      </a>
      <a
        role="button"
        class="navbar-burger burger"
        aria-label="menu"
        aria-expanded="false"
        @click="toggle_menu"
        ref="burger"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
    <div class="navbar-menu" ref="menu" v-if="user_data">
      <div class="navbar-end">
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link"> {{ $t("language") }} </a>

          <div class="navbar-dropdown">
            <a
              class="navbar-item"
              v-bind:class="{ 'is-selected': language == 'es' }"
              @click="change_language('es')"
            >
              {{ $t("spanish") }}
            </a>
            <a
              class="navbar-item"
              @click="change_language('en')"
              v-bind:class="{ 'is-selected': language == 'en' }"
            >
              {{ $t("english") }}
            </a>
            <a
              class="navbar-item"
              @click="change_language('fr')"
              v-bind:class="{ 'is-selected': language == 'fr' }"
            >
              {{ $t("french") }}
            </a>
          </div>
        </div>
        <div class="navbar-item">
          <div
            class="dropdown"
            v-bind:class="{ 'is-right': !isMobile }"
            data-position="bottom right"
            ref="user_options_dropdown"
            @mouseover="$refs.user_options_dropdown.classList.add('is-active')"
            @mouseleave="
              $refs.user_options_dropdown.classList.remove('is-active')
            "
            @click="$refs.user_options_dropdown.classList.toggle('is-active')"
          >
            <div class="dropdown-trigger">
              <div class="tags has-addons">
                <span class="tag is-medium"
                  ><span class="icon has-text-primary"
                    ><i class="fa fa-user"></i></span
                ></span>
                <span class="tag is-primary is-medium">{{ user_name }}</span>
              </div>
              <!-- <div
                class="tag"
                aria-haspopup="true"
                aria-controls="dropdown-menu2"
              >
                <span class="">{{ user_name }}</span>
                <span class="icon is-small has-text-primary">
                  <i class="fa fa-user"></i>
                </span>
              </div> -->
            </div>
            <div class="dropdown-menu options-menu" role="menu">
              <div class="dropdown-content">
                <div href="#" class="dropdown-item">
                  <span class="subtitle is-6">{{ $t("user options") }}</span>
                </div>
                <a href="#" class="dropdown-item" @click="user_settings">
                  <span class="icon has-text-info">
                    <i class="fa fa-user"></i>
                  </span>
                  <span>{{ $t("user settings") }}</span>
                </a>
                <a href="#" class="dropdown-item" @click="change_password">
                  <span class="icon has-text-warning">
                    <i class="fa fa-key"></i>
                  </span>
                  <span>{{ $t("change password") }}</span>
                </a>
                <a href="#" class="dropdown-item" @click="reload_session">
                  <span class="icon has-text-success">
                    <i class="fa fa-recycle"></i>
                  </span>
                  <span>{{ $t("reload session") }}</span>
                </a>
                <a href="#" class="dropdown-item" @click="get_latest">
                  <span class="icon has-text-info">
                    <i class="fa fa-cloud-download"></i>
                  </span>
                  <span>{{ $t("get latest app") }}</span>
                </a>
                <a class="dropdown-item" @click="logout">
                  <span class="icon has-text-danger">
                    <i class="fa fa-sign-out"></i>
                  </span>
                  <span>{{ $t("sign out") }}</span>
                </a>
                <dev-tools
                  @terminal="terminal"
                  ref="devtools"
                  v-if="is_developer"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <change-password-modal ref="change_password_modal" />
    <user-settings-modal ref="user_settings_modal" />
    <terminal-modal ref="terminal_modal" />
  </nav>
</template>

<script>
import settings from "../../../../settings.json";
import {
  set_language,
  del,
  get,
  get_permissions,
  get_user_data,
  success_message,
  error_message,
  // confirm_deletion_dialog,
} from "@/utils";
import ChangePasswordModal from "@/components/change_user_password_modal/Index.vue";
import UserSettingsModal from "@/components/user_settings_modal/Index.vue";
import DevTools from "./DevTools.vue";
import TerminalModal from "./terminal_modal/Index.vue";
import { isMobile } from "mobile-device-detect";

export default {
  name: "NavbarIndex",
  components: {
    ChangePasswordModal,
    UserSettingsModal,
    DevTools,
    TerminalModal,
  },
  data() {
    return {
      isMobile,
      language: settings.language,
      user_data: get_user_data(),
    };
  },
  computed: {
    user_name() {
      if (this.user_data) return this.user_data.username || "¿?";
      else return undefined;
    },
    is_developer() {
      if (this.user_data) return this.user_data.is_developer;
      else return false;
    },
  },
  methods: {
    logout() {
      let v = this;
      v.$root.loader(true);
      del("/system/authentication/logout")
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          v.$root.loader(false);
          localStorage.removeItem("session_token");
          localStorage.removeItem("user_data");
          localStorage.removeItem("login_data");
          localStorage.removeItem("shortkeys");
          v.$router.push({ name: "root" });
          v.$emit("logged_out");

          if (window.ModulAssistantSDK) {
            window.ModulAssistantSDK.destroy();
          }
        });
    },
    change_language(lang) {
      let v = this;
      this.language = lang;
      set_language(v, lang);
    },
    change_password() {
      let v = this;
      v.$refs.change_password_modal.show_modal();
    },
    user_settings() {
      let v = this;
      v.$refs.user_settings_modal.show_modal();
    },
    reload_session() {
      let v = this;
      // console.log("reloading session");
      v.$root.loader(true);
      get("/system/authentication/reload-session")
        .then((permissions) => {
          localStorage.removeItem("permissions");

          let perms = get_permissions();
          // console.log("perms", perms);
          localStorage.setItem(
            "permissions",
            JSON.stringify(permissions.concat(perms))
          );

          success_message(v.$t("session reloaded"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    toggle_menu() {
      let v = this;
      v.$refs.menu.classList.toggle("is-active");
      v.$refs.burger.classList.toggle("is-active");
    },
    terminal() {
      let v = this;
      v.$refs.terminal_modal.show_modal();
    },
    update_nav() {
      let v = this;
      v.user_data = get_user_data();
    },
    system_signal(signal) {
      let v = this;
      if (signal == "make_custom_build") v.$refs.devtools.custom_build();
      else if (signal == "reset_system") v.$refs.devtools.reset();
      else if (signal == "update_system") v.$refs.devtools.update_git();
      else if (signal == "generate_models") v.$refs.devtools.generate_models();
      else if (signal == "build") v.$refs.devtools.make_build();
    },
    get_latest() {
      window.location.reload(true);
    },
  },
  mounted() {
    setTimeout(() => {
      window
        .jQuery(".options-menu .dropdown-item")
        // .find(".dropdown-item")
        .on("mouseenter", function () {
          window.jQuery(this).addClass("is-active");
        })
        .on("mouseleave", function () {
          window.jQuery(this).removeClass("is-active");
        });
    }, 1000);
  },
};
</script>

<style>
.options-menu .dropdown-content {
  max-height: 600px;
  overflow-y: auto;
}
</style>
